import { flatten } from 'underscore';

import { csvExport } from 'shared/csv';

import { ScreenerEtfBackendModel } from './model';
import { ScreenerTable } from '../columns';

export const ScreenerExportService = {
	toCsv: (etfs: ScreenerEtfBackendModel[]) => {
		const currencies = ['RUB', 'USD', 'EUR'];

		var columns = [
			...ScreenerTable.ticker.createCsvColumns(currencies),
			...flatten(ScreenerTable.groups.map(group => group.columns.map(groupColumn => groupColumn.createCsvColumns(currencies))))
		];

		return csvExport(
			etfs, {
				columns: columns,
				format: {
					delimeter: ',',
					espaceChar: '"'
				}
			});
	}
}